import { render, staticRenderFns } from "./PresaleResultsSmall.vue?vue&type=template&id=4d029585"
import script from "./PresaleResultsSmall.vue?vue&type=script&lang=js"
export * from "./PresaleResultsSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports